/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader.js";
function UslyPrivacyPage() {
  const [activeTab, setActiveTab] = React.useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("landing-page");
    return function cleanup() {
      document.body.classList.remove("landing-page");
    };
  });
  return (
    <>
      <div className="section profile-content">
        <Container>
          <Row>
            <Col md="12">
              <p
                style={{
                  textAlign: "center",
                  marginTop: "12em",
                  marginBottom: "1em",
                }}
              >
                מדיניות פרטיות אפליקציית usly
              </p>
              <p style={{ textAlign: "right" }}>
                רואה חשיבות רבה במתן פרטיות למשתמשים באתרי אינטרנט, תוכנות,
                תכנים, פורומים, אפליקציות ובפעילויות במדיות שונות שמנהלת ומפעילה
                החברה, בין אם בעצמה ובין אם באמצעות מי מטעמה ("האפליקציה"). לכן,
                חשוב לנו להקנות לך ידע בדבר האופן בו אנו אוספים מידע לגבי
                המשתמשים והאופן בו אנו עושים שימוש במידע זה. עם כניסתך לאפליקציה
                ושימושך בה, אתה נותן את הסכמתך לתנאים ולהוראות הקבועות במסמך
                מדיניות זה. כמו כן עם הרשמתך לאיזה מהאתרים, תוכנות, תכנים,
                פורומים, משחקים, אפליקציות ו/או אילו מהפעילויות השונות שנערכות
                באפליקציה, הינך נותן את הסכמתך המפורשת לשליחתו של מידע פרסומי
                אליך, כפי שיפורט במסמך זה. החברה תהיה רשאית להתנות את הגלישה
                באפליקציה, לאתר ו/או לשירותים האחרים המוצעים בפלטפורמה כאמור,
                ברישום אשר יכלול פרטים של המשתמש ופרטים נוספים בהתאם לשיקול דעתה
                הבלעדי. במידה ותבחר שלא למסור את הנתונים אשר חובת מסירתם תצוין
                מפורשות באפליקציה, תהיה החברה רשאית למנוע את שימושך באפליקציה,
                באתר ו/או באילו מתכני האפליקציות ו/או אילו מפעילויות האתר, בהתאם
                לשיקול דעתה הבלעדי של החברה. לפיכך, ככל שאינך מסכים לאיזה
                מהוראותיו ו/או התנאים הקבועים במסמך זה, הינך מתבקש שלא להיכנס
                ושלא לעשות כל שימוש מכל מין וסוג שהוא באפליקציה, אתר ו/או באיזה
                מתכניו. החברה שומרת לעצמה את מלוא הזכות לשנות את המדיניות, כולה
                או חלקה, וזאת מבלי שתידרש ליתן על כך הודעה מראש ו/או בכתב. כל
                שינוי שתעשה כאמור החברה, ייכנס לתוקפו באופן מיידי וכל כניסה וכל
                שימוש מכל מין וסוג שהוא שתעשה באפליקציה ו/או באיזה מתכניה, יהווה
                את הסכמתך לשינויים שנעשו במסמך מדיניות זה. המידע הנאסף והשימוש
                בו
              </p>

              <p style={{ marginTop: 10, textAlign: "right" }}>
                המידע הנאסף לגבי כל משתמש הינו הן זה המוזן על ידך, הן זה הנאסף
                באמצעות האפליקציה ו\או אתר השונות בהן הינך עושה שימוש והן זה
                הנלמד מאופן ותוכן השימוש שלך. מידע זה נחלק לשני סוגים, האחד מידע
                שיש בו כדי להעיד על זהותך, כדוגמת פרטים אישיים שתזין במסגרת
                השימוש וכיו"ב, ואילו השני מידע שאין בו כדי להעיד על זהותך,
                כדוגמת העמודים בהם צפית, כתבות ופרסומות בהן התעניינת, מוצרים
                ושירותים שרכשת, נתונים סטטיסטיים בדבר האפליקציות בהן אתה עושה
                שימוש, נושאים שהתעניינת בהם וכיו"ב. השימוש באפליקיה טעון הזנתו
                של מידע מזהה ( להלן: תהליך הרישום) , אולם ככל שתבקש לעשות שימוש
                באיזה מהתכנים ו/או האפליקציות, ייתכן ותתבקש להזין מידע זה או
                לחלופין, ייתכן ומידע זה יתקבל בידינו מידי צדדים שלישיים מפעילי
                אותן אפליקציות. בנוסף, מאפשר השימוש באפליקציה, בתכנים
                ובאפליקציות, איסופו של מידע שאינו מזהה באשר למשתמש, קרי איסופו
                של מידע טכני באשר למכישר הנייד ו\או למחשב בו אתה עושה שימוש,
                פרטים טכניים של המשתמש שלך ברשת וכן כל מידע נוסף שיוזן על ידך
                במסגרת השימוש (בניגוד לפרטים כדוגמת פרטיים אישיים, פרטי אשראי
                וכיו"ב). שימת ליבך, כי ישנן אפליקציות הפועלות במסגרת רשתות
                חברתיות, אשר עצם השימוש בהן מקנה לצדדים שלישיים מידע באשר לשימוש
                שעשית באפליקציות, ואף שיתוף צדדים אלו במידע מזהה לגביך. המידע
                שייאסף כאמור, יישמר על ידי החברה במאגריה וייעשה בו שימוש בהתאם
                להוראות מסמך זה והדין, בין היתר לצורך העשרת התכנים המוצעים לך
                בעת עיונך ושימושך באפליקיה, וכן העשרת התכנים המוצעים לכלל משתמשי
                האפליקציה. המידע עוד יסייע בידי החברה לצורך עריכתם של נתונים
                סטטיסטיים בדבר פילוח המשתמשים השונים באפליקציה והתכנים המבוקשים
                על ידם, וכן ככל שנרשמת כאמור לאיזה מתכני האפליקציה, האתר,,
                האפליקציות ו/או הפעילויות, יאפשר שליחתו של מידע פרסומי, הן של
                החברה והן של מפרסמים שונים, אלא ככל שתבקש להסיר פרטיך מרשימות
                דיוור אלה, כפי שיצוין להלן. לידיעתך, באפשרותך לפעול למניעת
                שמירתו של מידע טכני עקב שימושך באפליקציה, אתר ו/או בתכניה,
                כדוגמת מידע אודות דפי האינטרנט בהם עיינת וכדומה, באמצעות שינוי
                ההגדרות בדפדפן המחשב שלך בהתאם להוראות ולהנחיות של הגורמים
                הבעלים ו/או המנהלים ו/או המפעילים של הדפדפן בו הינך משתמש. יחד
                עם זאת שימת ליבך כי ייתכן ושינוי הגדרות אלה, יימנע מאפשרותך
                לעשות שימוש עתידי באתר ו/או בחלק מתכניו או לחילופין, לא יאפשר
                לנו לפעול להתאמת האתר ו/או תכניו, לתחומי העניין שלך. כמו כן וככל
                שביקשת מהמחשב לזכור אוטומטית את סיסמת הכניסה שלך לאתר, ייתכן
                ששינוי ההגדרות יבטל את הכניסה האוטומטית ותתבקש להזמין את סיסמת
                הכניסה בשנית בכניסתך הבאה לאתר.
              </p>
              <p style={{ marginTop: 10, textAlign: "right" }}>
                אבטחת מידע: אנא שימת ליבך לכך שאמנם החברה פועלת על מנת לצמצם כל
                חשיפה וכל סיכון לחדירה שאינה מורשית לאתר ולמידע הנאסף כאמור, אך
                אין באפשרות החברה להבטיח כי אלו יהיו חסינים לחלוטין. שימושך על
                כן באתר הינו על אחריותך הבלעדית, הינך מוותר בזאת באופן בלתי חוזר
                על כל טענה, דרישה ו/או תביעה כנגד החברה לעניין זה, מסכים, מצהיר
                ומאשר כי החברה לא תהא אחראית לכל הוצאה, הפסד, נזק ו/או אבדן לגוף
                ו/או לרכוש כתוצאה משימושך באתר ו/או חשיפת המידע כאמור בשל חדירה
                שאינה מורשית.
              </p>
              <p style={{ marginTop: 10, textAlign: "right" }}>
                צדדים שלישיים: חלק מהפרסומות באפליקציה מקורן בשרתים של צדדים
                שלישיים לרבות של החברות המפרסמות ו/או של מי שהוסמך לפעול מטעם
                אותן חברות. בנוסף, בחלק מהמקרים עצם השימוש בשירותים באפליקציה
                עשוי לגרום לכך שהמשתמשים ייחשפו לפרסומות מותאמות אישית.
              </p>
              <p style={{ marginTop: 10, textAlign: "right" }}>
                שירותי צד שלישי המוטמעים באפליקציה: האפליקציה מארחת מעת לעת
                (ויכול ותארח בעתיד) כלים ופלטפורמות שיהיו בבעלות החברה ו/או
                בבעלות של צדדים שלישיים ("פלטפורמות של צדדים שלישיים"). מטרתם של
                אותם כלים היא הנגשה של תכנים מותאמים אישית של הגולשים ויצירה של
                אינטראקציות עם תכנים נוספים. לצורך כך, אוספות החברות מידע שמטרתו
                ניתוח של גלישת המשתמש באפליקציה ופרופיל התנהגותי, באמצעות אגירת
                המידע בשרתי החברה או בפלטפורמות צד ג שיש לחברה הסכמים מולן.
                מובהר כי המידע כאמור נאסף ישירות על ידי אותם צדדים שלישיים
                ובאחריותן. השימוש באותם שירותים של צד שלישי כפופים למדיניות
                הפרטיות של החברות המפעילות את השירותים.האפליקציה מאפשרת ועשויה
                לאפשר בעתיד הפעלה של פלטפורמות של צדדים שלישיים של חברות שונות.
              </p>
              <br />
            </Col>
          </Row>
          <br />
        </Container>
      </div>
    </>
  );
}

export default UslyPrivacyPage;
